import '../styles.css';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// import CardMedia from '@mui/material/CardMedia';
// import CardActions from '@mui/material/CardActions';

// import IconButton from '@mui/material/IconButton';
// import EmailIcon from '@mui/icons-material/Email';

function MembersCard({ data }) {
	return (
		<Card
			className="membersCard"
			sx={{ maxWidth: 310 }}
			variant="outlined"
		>
			<CardContent>
				<h3 style={{ fontSize: '20px' }}>{data.name}</h3>
				<br />
				<p style={{ fontSize: '14px' }}>
					{data.description}
				</p>
			</CardContent>

			{/* <CardActions>
					<a
						href={`https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=${data.emailID}`}
					>
						<IconButton>
							<EmailIcon />
						</IconButton>
					</a>
				</CardActions> */}
		</Card>
	);
}

export default MembersCard;
